
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Opret dashboard',
	'dashboard': 'Dashboard',
	'dashboardTemplate': 'Dashboardskabelon',
	'createAV': 'Opret',
	'createAvEditNameLabel': '1. Giv oversigten et navn',
	'createAvSelectTemplateLabel': '2. Vælg en skabelon',
	'tabLayoutLabel': 'Skillebladsskabelon',
	'infographicsLayoutLabel': 'Infografisk skabelon',
	'singlePageLayoutLabel': 'Skabelon til enkelt side',
	'customLayoutLabel': 'Tilpasset skabelon',
	'freeformTemplate': 'Frit format',
	'freeformTemplateDesc': 'Visualiseringer i et layout i frit format vises præcist med den størrelse, du angiver, på den placering, hvor du indsætter dem i oversigten, uanset skærmstørrelse. I de øvrige layout justeres størrelsen på og placeringen af visualiseringerne til at kunne være på skærmen.',
	'NoTemplate': 'Frit format',
	'Template1': 'Tom',
	'Template2': 'Titel 1 gange 2',
	'Template3': '2 over 1',
	'Template4': '4 over 1',
	'Template5': 'Bundtekst 1 gange 2',
	'Template6': '3 ved siden af 1 over 1',
	'Template7': '4 ved siden af 3 over 1',
	'Template8': '2 over 3 efter 2',
	'Template9': '2 efter 2',
	'Template10': '1 efter 2 ved siden af 2 efter 2 over 1',
	'Template11': '3 efter 1 over 1 efter 2',
	'Template12': '2 over 1 ved siden af 1 efter 2',
	'Template13': 'En ved siden af 1 efter 2 ved siden af 1 efter 4',
	'Template22': '1 over 2 gange 2',
	'Template14': '1 ved siden af 1',
	'Template15': '1 over 1 ved siden af 1',
	'Template16': '1 ved siden af 1 over 1',
	'Template17': '1 over 1 ved siden af 1 over 1',
	'Template18': '1 over 1 ved siden af 1',
	'Template19': '1 over 2 ved siden af 1',
	'Template20': '1 over 2 gange 1',
	'Template21': '1 over 1 over 2 gange 1',
	'Template23': 'Tom med opbevaringszone',
	'Infographics1': 'Tom',
	'Infographics2': '4 rækker',
	'Infographics3': '4 rækker med toptekster',
	'Infographics4': '2 gange 4',
	'Infographics5': 'Stor topfremvisning med 2 gange 2',
	'Infographics6': '2 gange 4 med lodret afstand',
	'Infographics7': '2 gange 4 forskudt',
	'Infographics8': 'Tennisbane',
	'Infographics9': '3 gange 4',
	'Infographics10': '4 gange 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Din dashboardskabelon er gemt.',
	'dashboard_template_prefix': 'Skabelon: "%{name}"',
	'dashboard_template_filters_removed': 'Filtre på lærredet er fjernet.',
	'createAvTabLabel': 'Skillebladsopdelt',
	'createAvInfographicsLabel': 'Infografik',
	'createAvSinglepageLabel': 'Enkelt side',
	'createAvCustomLabel': 'Tilpasset',
	'loadMoreLabel': 'Indlæs mere...',
	'backLabel': 'Gå tilbage',
	'addSourceLabel': 'Tilføj en kilde',
	'pinLabel': 'Fastgør',
	'errorLoadingDataSetMetaData': 'Der er opstået en fejl under læsning af metadataene',
	'errorLoadingDataSets': 'Der er opstået en fejl under indlæsning af liste over datasæt',
	'errorLoadingDataSet': 'Metadata for datasættet "%{datasetName}" blev ikke indlæst. Kontakt administratoren.',
	'okButton': 'OK',
	'createButton': 'Opret',
	'cancelButton': 'Annullér',
	'copyButton': 'Kopiér',
	'selectTemplateLabel': 'Vælg en skabelon',
	'createBoardTitle': 'Opret et dashboard',
	'createBoardSubtitle': 'Vælg en skabelon til dashboardet',
	'noSourcesSelectedLabel': 'Ingen kilder valgt',
	'find_label': 'Søg',
	'noDashboardFound': 'Dashboardet kan ikke hentes. Enten findes den ikke længere, eller også har du ikke rettighed til at få vist den.',
	'errorLabel': 'Fejl',
	'defaultName': 'Nyt dashboard',
	'noDashboardCapability': 'Du har ikke mulighed for at køre dashboardapplikationen',
	'noDashboardPermission': 'Du har ikke de nødvendige rettigheder til at få vist dette dashboard',
	'sourceNotFound': 'Visualiseringen kan ikke indlæses, fordi den tilknyttede kilde "%{sourceName}" ikke er tilgængelig',
	'cmDuplicateName': 'Der findes allerede et element med dette navn. Prøv at angive et andet navn.',
	'cmEmptySelection': 'Dashboardet er slettet. Prøv at gemme som et nyt dashboard.',
	'propTheme': 'Visuelt tema',
	'legacyThemeLabel': 'Ældre',
	'carbonGrey10Label': 'Carbon X - lys',
	'carbonGrey100Label': 'Carbon X - mørk',
	'titleTextLabel': 'Titel',
	'titleSmallTextLabel': 'Titel lille',
	'subtitleTextLabel': 'Undertitel',
	'bodyTextLabel': 'Indhold',
	'bodySmallTextLabel': 'Indhold lille',
	'captionTextLabel': 'Overskrift',
	'quoteTextLabel': 'Citat',
	'quoteSmallTextLabel': 'Citat lille',
	'responsiveTextLabel': 'Automatisk størrelse',
	'mediaWidgetLabel': 'Medier',
	'webpageWidgetLabel': 'Webside',
	'imageWidgetLabel': 'Billede',
	'textWidgetLabel': 'Tekst',
	'notebookWidgetLabel': 'Notesbog',
	'multipurposeWidgetLabel': 'Multiformål',
	'textPlaceHolder': 'Klik for at redigere tekst',
	'titlePlaceHolder': 'Klik for at redigere titlen',
	'toggleEditModeLabel': 'Skift for at redigere',
	'togglePreviewModeLabel': 'Skift til prøvefremvisning',
	'editDashboardCoachMarkTitle': 'Redigér dashboard',
	'editDashboardCoachMarkContents': 'Klik på blyantsikonen for at redigere dashboardet.',
	'addDataCoachMarkTitle': 'Tilføj data',
	'addDataDashboardCoachMarkContents': 'Træk data fra datavinduet, og placér dem på dashboardet.',
	'pageSelectWarning': 'Vælg et skilleblad.',
	'screenshot_label': 'Dashboard %{title}',
	'screenshot_label_tab': 'Skilleblad %{tabName} for dashboard %{title}',
	'dataAssetPropertiesLabel': 'Egenskaber for visualisering',
	'modelFilter': 'Filtrér',
	'invertSelectionToolTip': 'Vend om på filtervalg',
	'clearFilterValueToolTip': 'Ryd filterværdier',
	'invertFilterSelection': 'Omvendt',
	'clearTextFilterValue': 'Ryd',
	'filterConditionLabel': 'Filterbetingelse',
	'applyFilter': 'Anvend filter',
	'itemCountText': '%{itemCount} elementer valgt',
	'itemExcludeCountText': '%{itemCount} element(er) er udeladt',
	'moreMembers': 'Vis mere...',
	'searchHierarchyMembers': 'Søg efter medlemmer...',
	'propHideEmpty': 'Skjul tomme',
	'propColorOrder': 'Farverækkefølge',
	'propElementColor': 'Visualiseringselementfarve',
	'propLineColor': 'Linjefarve',
	'propLineAndSymbolColor': 'Linje- og symbolfarve',
	'propColumnColor': 'Kolonnefarve',
	'propBarColor': 'Søjlefarve',
	'propWordColor': 'Ordfarve',
	'propAreaColor': 'Områdefarve',
	'propRadialbarColor': 'Farve på radialsøjle',
	'propColorPalettes': 'Farvepaletter',
	'propDashboardColorPalette': 'Aktuel dashboardpalet',
	'propNewDashboardPaletteLabel': 'Opret en tilpasset dashboardpalet',
	'propDashboardChangePaletteLink': 'Skift dashboardpalet',
	'propHideLeafNode': 'Skjul primære etiketter',
	'propOpacity': 'Uigennemsigtighed',
	'propOpacityDescription': 'Gør objektet mere eller mindre uigennemsigtigt. Skriv en værdi mellem 0 og 100',
	'addATab': 'Tilføj et nyt skilleblad',
	'propFredIsRed': 'Farvekonsistens',
	'areaChartCaption': 'Område',
	'areaChartDataSlot_categoriesLabel': 'Akseetiket',
	'areaChartDataSlot_valuesLabel': 'Værdi',
	'areaChartProp_colorPaletteLabel': 'Farvepaletter',
	'areaChartProp_lineColorLabel': 'Områdefarve',
	'areaChartProp_interpolationLabel': 'Bløde linjer',
	'areaChartProp_interpolationDescription': 'Linjer, der forbinder datapunkterne, er buede.',
	'areaChartProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'areaChartProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'areaChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'areaChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'areaChartProp_suppressZerosLabel': 'Skjul tomme',
	'areaChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'barChartCaption': 'Søjle',
	'barChartDataSlot_categoriesLabel': 'Akseetiket',
	'barChartDataSlot_valuesLabel': 'Værdi',
	'barChartProp_colorPaletteLabel': 'Farvepaletter',
	'barChartProp_elementColorLabel': 'Søjlefarve',
	'barChartProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'barChartProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'barChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'barChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'barChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'barChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'barChartProp_suppressZerosLabel': 'Skjul tomme',
	'barChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'columnChartCaption': 'Kolonne',
	'columnChartDataSlot_categoriesLabel': 'Akseetiket',
	'columnChartDataSlot_valuesLabel': 'Værdi',
	'columnChartProp_colorPaletteLabel': 'Farvepaletter',
	'columnChartProp_elementColorLabel': 'Kolonnefarve',
	'columnChartProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'columnChartProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'columnChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'columnChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'columnChartProp_suppressZerosLabel': 'Skjul tomme',
	'columnChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'bubbleChartCaption': 'Boble',
	'bubbleChartDataSlot_xAxisLabel': 'Vandret akse',
	'bubbleChartDataSlot_yAxisLabel': 'Lodret akse',
	'bubbleChartDataSlot_sizeLabel': 'Størrelse efter',
	'bubbleChartDataSlot_colorLabel': 'Farve efter',
	'bubbleChartProp_colorPaletteLabel': 'Farvepaletter',
	'bubbleChartProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'bubbleChartProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'bubbleChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'bubbleChartProp_hideLegendLabel': 'Skjul beskrivelse',
	'bubbleChartProp_hideLegendDescription': 'Skjul beskrivelsen.',
	'bubbleChartProp_legendPositionLabel': 'Beskrivelsesposition',
	'lineChartCaption': 'Linje',
	'lineChartDataSlot_categoriesLabel': 'Akseetiket',
	'lineChartDataSlot_valuesLabel': 'Værdi',
	'lineChartProp_colorPaletteLabel': 'Farvepaletter',
	'lineChartProp_lineColorLabel': 'Linje- og symbolfarve',
	'lineChartProp_symbolShapeLabel': 'Symbolform',
	'lineChartProp_hideSymbolsLabel': 'Skjul symboler',
	'lineChartProp_hideSymbolsDescription': 'Skjul symboler',
	'lineChartProp_hideDataLinesLabel': 'Skjul linje(r)',
	'lineChartProp_hideDataLinesDescription': 'Skjul linje(r)',
	'lineChartProp_interpolationLabel': 'Bløde linjer',
	'lineChartProp_interpolationDescription': 'Linjer, der forbinder datapunkterne, er buede.',
	'lineChartProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'lineChartProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'lineChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'lineChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'lineChartProp_suppressZerosLabel': 'Skjul tomme',
	'lineChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'packedBubbleChart1CatCaption': 'Pakket boble',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorier',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Størrelse efter',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Farvepaletter',
	'packedBubbleChart1CatProp_elementColorLabel': 'Boblefarve',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Skjul etiket',
	'packedBubbleChart1CatProp_hideValueLabel': 'Skjul værdi',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Skjul tomme',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'heatChartCaption': 'Varme',
	'heatChartDataSlot_valuesLabel': 'Varme efter',
	'heatChartDataSlot_xAxisLabel': 'Vandret akse',
	'heatChartDataSlot_yAxisLabel': 'Lodret akse',
	'heatChartProp_colorPaletteLabel': 'Farvepaletter',
	'heatChartProp_heatScalePaletteLabel': 'Farverækkefølge',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'heatChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'heatChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'heatChartProp_suppressZerosLabel': 'Skjul tomme',
	'heatChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'heatChartProp_hideLegendLabel': 'Skjul beskrivelse',
	'heatChartProp_hideLegendDescription': 'Skjul beskrivelsen.',
	'heatChartProp_legendPositionLabel': 'Beskrivelsesposition',
	'pieChartCaption': 'Lagkage',
	'pieChartDataSlot_categoriesLabel': 'Kategorier',
	'pieChartDataSlot_valuesLabel': 'Værdi',
	'pieChartProp_colorPaletteLabel': 'Farvepaletter',
	'pieChartProp_hideRadialValueLabel': 'Skjul værdi',
	'pieChartProp_pieAsDonutLabel': 'Vis som kransdiagram',
	'pieChartProp_pieAsDonutDescription': 'Vis som kransdiagram',
	'pieChartProp_suppressZerosLabel': 'Skjul tomme',
	'pieChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'pieChartProp_hideLegendLabel': 'Skjul beskrivelse',
	'pieChartProp_hideLegendDescription': 'Skjul beskrivelsen.',
	'pieChartProp_legendPositionLabel': 'Beskrivelsesposition',
	'map1measureCaption': 'Kort',
	'map1measureDataSlot_categoriesLabel': 'Områder',
	'map1measureDataSlot_valuesLabel': 'Områdevarme',
	'map1measureProp_colorPaletteLabel': 'Farvepaletter',
	'map1measureProp_heatScalePaletteLabel': 'Farverækkefølge',
	'map1measureProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'map1measureProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'map1measureProp_suppressZerosLabel': 'Skjul tomme',
	'map1measureProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'map1measureProp_hideLegendLabel': 'Skjul beskrivelse',
	'map1measureProp_hideLegendDescription': 'Skjul beskrivelsen.',
	'map1measureProp_legendPositionLabel': 'Beskrivelsesposition',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Kategorier',
	'radialChartDataSlot_valuesLabel': 'Værdi',
	'radialChartProp_colorPaletteLabel': 'Farvepaletter',
	'radialChartProp_elementColorLabel': 'Farve på radialsøjle',
	'radialChartProp_hideRadialTitleLabel': 'Skjul titel',
	'radialChartProp_hideRadialValueLabel': 'Skjul værdi',
	'radialChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'radialChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'radialChartProp_suppressZerosLabel': 'Skjul tomme',
	'radialChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'pointChart1catCaption': 'Punkt',
	'pointChart1catDataSlot_valuesLabel': 'Værdi',
	'pointChart1catDataSlot_categoriesLabel': 'Akseetiket',
	'pointChart1catProp_colorPaletteLabel': 'Farvepaletter',
	'pointChart1catProp_elementColorLabel': 'Farve på form',
	'pointChart1catProp_symbolShapeLabel': 'Symbolform',
	'pointChart1catProp_symbolFillLabel': 'Udfyld form',
	'pointChart1catProp_symbolFillDescription': 'Vis udfyldningsfarve for symbolerne.',
	'pointChart1catProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'pointChart1catProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'pointChart1catProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'pointChart1catProp_suppressZerosLabel': 'Skjul tomme',
	'pointChart1catProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'scatterPlotChartNoCatCaption': 'Punktplot',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vandret akse',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Lodret akse',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Farvepaletter',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Elementfarve',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symbolform',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Udfyld form',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Vis udfyldningsfarve for symbolerne.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'radialBarChartCaption': 'Radialsøjle',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorier',
	'radialBarChartDataSlot_valuesLabel': 'Værdi',
	'radialBarChartProp_colorPaletteLabel': 'Farvepaletter',
	'radialBarChartProp_elementColorLabel': 'Farve på radialsøjle',
	'radialBarChartProp_hideRadialTitleLabel': 'Skjul titel',
	'radialBarChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'radialBarChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'radialBarChartProp_suppressZerosLabel': 'Skjul tomme',
	'radialBarChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'lineColumnComboChartCaption': 'Linje og kolonne',
	'lineColumnComboChartDataSlot_categoryLabel': 'Akseetiket',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Linjeværdi',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Kolonneværdi',
	'lineColumnComboChartProp_colorPaletteLabel': 'Farvepaletter',
	'lineColumnComboChartProp_elementColorLabel': 'Kolonnefarve',
	'lineColumnComboChartProp_lineColorLabel': 'Linje- og symbolfarve',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symbolform',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Skjul symboler',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Skjul symboler',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Skjul linje(r)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Skjul linje(r)',
	'lineColumnComboChartProp_interpolationLabel': 'Bløde linjer',
	'lineColumnComboChartProp_interpolationDescription': 'Linjer, der forbinder datapunkterne, er buede.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Skjul gitterlinjer',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Skjul gitterlinjer',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetiteletiketter',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Skjul aksernes titler.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Skjul tomme',
	'lineColumnComboChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'lineColumnComboChartProp_hideLegendLabel': 'Skjul beskrivelse',
	'lineColumnComboChartProp_hideLegendDescription': 'Skjul beskrivelsen.',
	'lineColumnComboChartProp_legendPositionLabel': 'Beskrivelsesposition',
	'summaryCaption': 'Opsummering',
	'areaName': 'Område',
	'areaDescription': 'Område',
	'areaDataSlot_colorLabel': 'Farve efter',
	'areaDataSlot_valuesLabel': 'Værdi',
	'areaDataSlot_categoriesLabel': 'Akseetiket',
	'bubbleName': 'Boble',
	'bubbleDescription': 'Boble',
	'bubbleDataSlot_yAxisLabel': 'Lodret akse',
	'bubbleDataSlot_xAxisLabel': 'Vandret akse',
	'bubbleDataSlot_sizeLabel': 'Størrelse efter',
	'bubbleDataSlot_colorLabel': 'Farve efter',
	'clusterBarName': 'Søjle',
	'clusterBarDescription': 'Søjle',
	'clusterBarDataSlot_colorLabel': 'Farve efter',
	'clusterBarDataSlot_valuesLabel': 'Værdi',
	'clusterBarDataSlot_categoriesLabel': 'Akseetiket',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Værdi',
	'clusterColumnName': 'Kolonne',
	'clusterColumnDescription': 'Kolonne',
	'clusterColumnDataSlot_colorLabel': 'Farve efter',
	'clusterColumnDataSlot_valuesLabel': 'Værdi',
	'clusterColumnDataSlot_categoriesLabel': 'Akseetiket',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Værdi',
	'clusterLineName': 'Linje',
	'clusterLineDescription': 'Linje',
	'clusterLineDataSlot_colorLabel': 'Farve efter',
	'clusterLineDataSlot_valuesLabel': 'Lodret akse',
	'clusterLineDataSlot_categoriesLabel': 'Vandret akse',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Værdi',
	'gridName': 'Gitter',
	'gridDescription': 'Gitter',
	'gridDataSlot_grid_colsLabel': 'Kolonne',
	'heatName': 'Varme',
	'heatDescription': 'Varme',
	'heatDataSlot_yAxisLabel': 'Lodret akse',
	'heatDataSlot_xAxisLabel': 'Vandret akse',
	'heatDataSlot_valuesLabel': 'Varme efter',
	'lineColumnComboName': 'Linje og kolonne',
	'lineColumnComboDescription': 'Linje og kolonne',
	'lineColumnComboDataSlot_lineValueLabel': 'Linjeværdi',
	'lineColumnComboDataSlot_categoryLabel': 'Akseetiket',
	'lineColumnComboDataSlot_columnValueLabel': 'Kolonneværdi',
	'mapName': 'Ældre kort',
	'mapDescription': 'Ældre kort',
	'mapDataSlot_sizeLabel': 'Punktstørrelse',
	'mapDataSlot_valuesLabel': 'Områdevarme',
	'mapDataSlot_sizeHeatLabel': 'Punktvarme',
	'mapDataSlot_categoriesLabel': 'Områder',
	'packedBubbleName': 'Pakket boble',
	'packedBubbleDescription': 'Pakket boble',
	'packedBubbleDataSlot_sizeLabel': 'Størrelse efter',
	'packedBubbleDataSlot_colorLabel': 'Farve efter',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorier',
	'pieName': 'Lagkage',
	'pieDescription': 'Lagkage',
	'pieDataSlot_valuesLabel': 'Værdi',
	'pieDataSlot_categoriesLabel': 'Kategorier',
	'playerName': 'Dataafspiller',
	'playerDescription': 'Dataafspiller',
	'playerDataSlot_categoriesLabel': 'Akseetiket',
	'pointName': 'Punkt',
	'pointDescription': 'Punkt',
	'pointDataSlot_colorLabel': 'Farve efter',
	'pointDataSlot_valuesLabel': 'Værdi',
	'pointDataSlot_categoriesLabel': 'Akseetiket',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Værdi',
	'radialDataSlot_maxSizeLabel': 'Maksimumsværdi',
	'radialDataSlot_categoriesLabel': 'Kategorier',
	'radialBarName': 'Radialsøjle',
	'radialBarDescription': 'Radialsøjle',
	'radialBarDataSlot_valuesLabel': 'Værdi',
	'radialBarDataSlot_categoriesLabel': 'Kategorier',
	'scatterPlotName': 'Punktplot',
	'scatterPlotDescription': 'Punktplot',
	'scatterPlotDataSlot_yAxisLabel': 'Lodret akse',
	'scatterPlotDataSlot_xAxisLabel': 'Vandret akse',
	'scatterPlotDataSlot_colorLabel': 'Farve efter',
	'scatterPlotDataSlot_categoriesLabel': 'Punkter',
	'stackedBarName': 'Stakket søjle',
	'stackedBarDescription': 'Stakket søjle',
	'stackedBarDataSlot_colorLabel': 'Farve efter',
	'stackedBarDataSlot_valuesLabel': 'Værdi',
	'stackedBarDataSlot_categoriesLabel': 'Akseetiket',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Værdi',
	'stackedColumnName': 'Stakket kolonne',
	'stackedColumnDescription': 'Stakket kolonne',
	'stackedColumnDataSlot_colorLabel': 'Farve efter',
	'stackedColumnDataSlot_valuesLabel': 'Værdi',
	'stackedColumnDataSlot_categoriesLabel': 'Akseetiket',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Værdi',
	'summaryChartName': 'Opsummering',
	'summaryChartDescription': 'Opsummering',
	'summaryChartDataSlot_valuesLabel': 'Værdi',
	'treeMapName': 'Træstruktur',
	'treeMapDescription': 'Træstruktur',
	'treeMapDataSlot_colorLabel': 'Varme efter',
	'treeMapDataSlot_valuesLabel': 'Størrelse efter',
	'treeMapDataSlot_categoriesLabel': 'Niveau 1',
	'treeMapDataSlot_level3Label': 'Niveau 3',
	'treeMapDataSlot_level2Label': 'Niveau 2',
	'wordCloudName': 'Ordsky',
	'wordCloudDescription': 'Ordsky',
	'wordCloudDataSlot_colorLabel': 'Farve efter',
	'wordCloudDataSlot_scaleLabel': 'Størrelse efter',
	'wordCloudDataSlot_wordLabel': 'Ord',
	'treeMap1Cat1MeasureChartCaption': 'Træstruktur',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Niveau 1',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Størrelse efter',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Farvepaletter',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Farvepaletter',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Farvepaletter',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Farvepaletter',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Farvepaletter',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Farvepaletter',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Skjul tomme',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Skjul beskrivelse',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Skjul beskrivelsen.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Beskrivelsesposition',
	'wordChart1Cat1MeasureCaption': 'Ordsky',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Ord',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Størrelse efter',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Farvepaletter',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Ordfarve',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Bevar akseskala',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Vis altid minimums- og maksimumsværdierne på akserne.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Skjul tomme',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Skjul kategorier, der ikke har tilknyttede værdier.',
	'missingDataSetData': 'Data til dette datasæt er ikke tilgængelige. Opfrisk datasættet, eller kontakt administratoren for at få adgang til kilden.',
	'hideShowSummaries': 'Skjul vis opsummeringer',
	'crosstabName': 'Krydstabel',
	'value_is_not_available': 'Ikke tilgængelig',
	'swapRowsAndColumns': 'Byt om på rækker og kolonner',
	'NoPinsCollected': 'Ingen fastgjorte visualiseringer',
	'pinSearchOld': 'Søg efter mine tegnestifter',
	'pinDeletedToast': 'Tegnestift blev fjernet',
	'pinAddedToast': 'Tegnestiften blev føjet til Mine tegnestifter',
	'pinRetrieveError': 'En eller flere tegnestifter kan ikke hentes. Prøv igen senere.',
	'pinErrorTitle': 'Fejl under fastgørelse',
	'pinRemove': 'Fjern tegnestiften',
	'deletePin': 'Slet tegnestiften',
	'dataset_time': 'klokkeslæt',
	'dataset_date': 'dato',
	'dataset_location': 'placering',
	'dataset_number': 'tal',
	'dataset_text': 'tekst',
	'widgetConditionalFormatLabel': 'Aktivér/deaktivér kontrolelementer i betinget format',
	'deletePinConfirmationMessage': 'Er du sikker på, at du vil slette denne tegnestift? Handlingen kan ikke fortrydes.',
	'deletePinConfirm': 'Bekræft sletning',
	'pinDeleteError': 'En eller flere tegnestifter kan ikke slettes. Prøv igen senere.',
	'metadataPickerTitle': 'Opret datasæt',
	'moreTitle': 'Mere',
	'remove_slider_handle': 'Fjern håndtag',
	'missingFiltering': 'Kolonne mangler:',
	'unSupportedPromptType': 'Promptscenariet understøttes ikke i øjeblikket.',
	'preAggregateLabel': 'Anvend promptværdier fra datakilden',
	'postAggregateLabel': 'Anvend promptværdier i rapporten',
	'preAggregateText': 'Intervallet anvender værdierne i datakilden - ikke værdierne, der vises på dashboardet.',
	'tabName_general': 'Generelt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Detaljer',
	'tabName_textDetails': 'Tekstdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Detaljer om medier', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Detaljer om websider', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Billeddetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualisering',
	'sectionName_canvas': 'Lærred',
	'sectionName_colorsAndThemes': 'Farve og tema',
	'colorsAndThemes_legacyWarning': 'Det aktuelle dashboard anvender et tema fra en tidligere release. Hvis du ændrer temaet og gemmer dashboardet permanent, bliver adgangen til de tidligere temapaletter fjernet.',
	'sectionName_details': 'Detaljer',
	'sectionName_positionAndStyle': 'Placering og typografi',
	'sectionName_appearance': 'Udseende', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Udvidet',
	'sectionName_layout': 'Layout', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Skilleblade',
	'sectionName_tabTitle': 'Etiket',
	'sectionName_tabBackground': 'Baggrund',
	'addDataSourceDialogTitle': 'Tilføj en datakilde',
	'addDataSourceDialogButtonLabel': 'Tilføj',
	'shapesDoubleChevron': 'Dobbelt vinkel',
	'widgetsPanelTitle': 'Widgetter',
	'widgetsPanelBasicsTab': 'Grundlæggende funktioner',
	'widgetsPanelImageLibraryTab': 'Billeder',
	'widgetsPanelSectionStandard': 'Standard',
	'widgetsPanelSectionAdvanced': 'Udvidet',
	'widgetsPanelSectionShapes': 'Former',
	'customWidgetsTitle': 'Tilpassede widgetter',
	'filterItemCanvasMove': 'Tilføj til lærred',
	'filterOverflowMenu_Global': 'Alle skilleblades overløbsmenu',
	'filterOverflowMenu_Tab': 'Dette skilleblads overløbsmenu',
	'filterOverflowMenu_Item': 'Overløbsmenu for filter',
	'filterOverflowMenu_Single': 'Overløbsmenu',
	'filterItemEdit': 'Redigér filterværdier',
	'filterDeleteAllItems': 'Slet alle filtre',
	'filterClearAllItems': 'Ryd alle filtre',
	'filterClearSelection': 'Ryd filter',
	'filterPlayerMode': 'Vis afspiller',
	'filterStaticMode': 'Vis liste',
	'filterInvertSelection': 'Vend om på filter',
	'filterIconLabel_Global': 'Alle skilleblade',
	'filterIconLabel_Single': 'Filtre',
	'filterIconLabel_Tab': 'Dette skilleblad',
	'filterIconTooltip_Global': 'Alle skilleblade',
	'filterIconTooltip_Tab': 'Dette skilleblad',
	'filterIconTooltip_Single': 'Filtre',
	'filterItemDelete': 'Slet filter',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'alt undtagen: %{from}-%{to}',
	'filterExcept': 'undtagen %{values}',
	'filterAll': 'Alle',
	'filterBlank': '(tom)',
	'filterDisableRangeInvert': 'Ikke tilgængelig, når kolonnen er i filtret "Alle skilleblade".',
	'filterDisableHierarchyInvert': 'Ikke tilgængelig, når kolonnen er i et hierarkifilter.',
	'filterSelectedOfTotal': '%{selected} of %{totalMembers}',
	'filter_date_before': 'Før %{to}',
	'filter_date_before_except': 'Ikke før %{to}',
	'filter_date_after': 'Efter %{from}',
	'filter_date_after_except': 'Ikke efter %{from}',
	'filter_date_between': 'Mellem %{from}-%{to}',
	'filter_date_between_except': 'Ikke mellem %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Træk og placér data her for at filtrere alle faner.',
	'filter_drag_and_drop_current_tab': 'Træk og placér data her for at filtrere denne fane.',
	'filter_drag_and_drop_single_dock': 'Træk og placér data her for at filtrere',
	'errMsgFilterItemGenericTitle': 'Filterværdier kan ikke indlæses',
	'widgetChromeRotate': 'Rotér',
	'toolbarRegionLabel': 'Værktøjslinje',
	'toolbarActionDelete': 'Slet',
	'toolbarActionGroup': 'Gruppe',
	'toolbarActionUngroup': 'Ophæv gruppe',
	'toolbarActionOrderToFront': 'Placér forrest',
	'toolbarActionOrderToBack': 'Placér bagest',
	'toolbarActionEditTitle': 'Redigér titlen',
	'toolbarActionWrapTitle': 'Ombryd titlen',
	'toolbarActionPin': 'Saml',
	'toolbarActionPinOld': 'Fastgør',
	'toolbarActionAlign': 'Justér',
	'alignWidgetLeft': 'Venstre',
	'alignWidgetCenter': 'Centrér',
	'alignWidgetRight': 'Højre',
	'alignWidgetTop': 'Øverst',
	'alignWidgetMiddle': 'I midten',
	'alignWidgetBottom': 'Nederst',
	'toolbarChangeVisualization': 'Skift visualisering',
	'multipurposeHeader': 'Vælg en widgettype',
	'multipurposePlaceholderText': 'Vælg en af widgetterne for at komme i gang.',
	'live_label': 'Diagram',
	'filter_label': 'Filtrér',
	'one_named_live': '%{name} diagram',
	'one_named_live_numbered': '%{name} diagram (%{number})',
	'one_unknown_live': 'Diagram',
	'one_unknown_live_numbered': 'Diagram (%{number})',
	'few_live': 'Gruppe af %{count}-diagrammer',
	'many_live': 'Gruppe af %{count}-diagrammer',
	'one_custom': 'Tilpasset widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name}-filter',
	'one_named_filter_numbered': '%{name} filter (%{number})',
	'one_unknown_filter': 'Filtrér',
	'one_unknown_filter_numbered': 'Filtrér (%{number})',
	'few_filter': 'Gruppe af %{count}-filtre',
	'many_filter': 'Gruppe af %{count}-filtre',
	'LIVE_bar_has_mapping': '%{values}-søjlediagram',
	'LIVE_bar_has_mapping_numbered': '%{values} søjlediagram (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} efter %{values}-søjlediagram',
	'LIVE_bar_opt_mapping_numbered': '%{categories} efter %{values}-søjlediagram (%{number})',
	'LIVE_bar_no_mapping': 'Tomt søjlediagram',
	'LIVE_bar_no_mapping_numbered': 'Tomt søjlediagram (%{number})',
	'LIVE_bar_named': '%{name}-søjlediagram',
	'LIVE_bar_named_numbered': '%{name} søjlediagram (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} stakket søjlediagram',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} stakket søjlediagram (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} by %{values} stakket søjlediagram',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} efter %{values} stakket søjlediagram (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Tomt stakket søjlediagram',
	'LIVE_stacked_bar_no_mapping_numbered': 'Tomt stakket søjlediagram (%{number})',
	'LIVE_stacked_bar_named': '%{name} stakket søjlediagram',
	'LIVE_stacked_bar_named_numbered': '%{name} stakket søjlediagram (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} efter %{x} og %{y}-boblediagram',
	'LIVE_bubble_has_mapping_numbered': '%{categories} efter %{x} og%{y} boblediagram (%{number})',
	'LIVE_bubble_no_mapping': 'Tomt boblediagram',
	'LIVE_bubble_no_mapping_numbered': 'Tomt boblediagram (%{number})',
	'LIVE_bubble_named': '%{name}-boblediagram',
	'LIVE_bubble_named_numbered': '%{name} boblediagram (%{number})',
	'LIVE_composite_has_mapping': '%{categories} efter %{columnValue} og %{lineValue} sammensat diagram',
	'LIVE_composite_has_mapping_numbered': '%{categories} efter %{columnValue} og %{lineValue} sammensat diagram (%{number})',
	'LIVE_composite_no_mapping': 'Tomt sammensat diagram',
	'LIVE_composite_no_mapping_numbered': 'Tomt sammensat diagram (%{number})',
	'LIVE_composite_named': '%{name} sammensat diagram',
	'LIVE_composite_named_numbered': '%{name} sammensat diagram (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} beslutningstræstruktur',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} beslutningstræstruktur (%{number})',
	'LIVE_decision_tree_no_mapping': 'Tomt beslutningstræ',
	'LIVE_decision_tree_no_mapping_numbered': 'Tom beslutningstræstruktur (%{number})',
	'LIVE_decision_tree_named': '%{name} beslutningstræstruktur',
	'LIVE_decision_tree_named_numbered': '%{name} beslutningstræstruktur (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} pakket boblediagram',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} pakket boblediagram (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Tomt pakket boblediagram',
	'LIVE_packed_bubble_no_mapping_numbered': 'Tomt pakket boblediagram (%{number})',
	'LIVE_packed_bubble_named': '%{name} pakket boblediagram',
	'LIVE_packed_bubble_named_numbered': '%{name} pakket boblediagram (%{number})',
	'LIVE_pie_has_mapping': '%{categories} efter %{values} lagkagediagram',
	'LIVE_pie_has_mapping_numbered': '%{categories} efter %{values} lagkagediagram (%{number})',
	'LIVE_pie_no_mapping': 'Tomt lagkagediagram',
	'LIVE_pie_no_mapping_numbered': 'Tomt lagkagediagram (%{number})',
	'LIVE_pie_named': '%{name}-lagkagediagram',
	'LIVE_pie_named_numbered': '%{name} lagkagediagram (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} efter %{values} donut-diagram',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} efter %{values} donut-diagram (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Tomt kransdiagram',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Tomt donut-diagram (%{number})',
	'LIVE_pie_as_donut_named': '%{name}-donut-diagram',
	'LIVE_pie_as_donut_named_numbered': '%{name} donut-diagram (%{number})',
	'LIVE_line_has_mapping': '%{categories} efter %{values} linjediagram',
	'LIVE_line_has_mapping_numbered': '%{categories} efter %{values} linjediagram (%{number})',
	'LIVE_line_no_mapping': 'Tomt linjediagram',
	'LIVE_line_no_mapping_numbered': 'Tomt linjediagram (%{number})',
	'LIVE_line_named': '%{name}-linjediagram',
	'LIVE_line_named_numbered': '%{name} linjediagram (%{number})',
	'LIVE_area_has_mapping': '%{categories} efter %{values}-områdediagram',
	'LIVE_area_has_mapping_numbered': '%{categories} efter %{values} områdediagram (%{number})',
	'LIVE_area_no_mapping': 'Tomt områdediagram',
	'LIVE_area_no_mapping_numbered': 'Tomt områdediagram (%{number})',
	'LIVE_area_named': '%{name} områdediagram',
	'LIVE_area_named_numbered': '%{name} områdediagram (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} by %{values} stakket procentområdediagram',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} by %{values} stakket procentområdediagram (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Tomt stakket procentområdediagram',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Tomt stakket procentområdediagram (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} stakket procentområdediagram',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} stakket procentområdediagram (%{number})',
	'LIVE_heatmap_has_mapping': '%{color}-varmekort',
	'LIVE_heatmap_has_mapping_numbered': '%{color}-varmekort (%{number})',
	'LIVE_heatmap_no_mapping': 'Tomt varmekort',
	'LIVE_heatmap_no_mapping_numbered': 'Tomt varmekort (%{number})',
	'LIVE_heatmap_named': '%{name}-varmekort',
	'LIVE_heatmap_named_numbered': '%{name}-varmekort (%{number})',
	'LIVE_network_opt_mapping': '%{categories} efter %{series} og %{values}-netværk',
	'LIVE_network_opt_mapping_numbered': '%{categories} efter %{series} og %{values} netværk (%{number})',
	'LIVE_network_has_mapping': '%{categories} efter %{series} netværk',
	'LIVE_network_has_mapping_numbered': '%{categories} efter %{series} netværk (%{number})',
	'LIVE_network_no_mapping': 'Tomt netværk',
	'LIVE_network_no_mapping_numbered': 'Tomt netværk (%{number})',
	'LIVE_network_named': '%{name} netværk',
	'LIVE_network_named_numbered': '%{name} netværk (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} efter %{values} radialsøjlediagram',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} efter %{values} radialsøjlediagram (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} radialsøjlediagram',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} radialsøjlediagram (%{number})',
	'LIVE_radial_bar_no_mapping': 'Tomt radialsøjlediagram',
	'LIVE_radial_bar_no_mapping_numbered': 'Tomt radialsøjlediagram (%{number})',
	'LIVE_radial_bar_named': '%{name} radialsøjlediagram',
	'LIVE_radial_bar_named_numbered': '%{name} radialsøjlediagram (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spiraldiagram',
	'LIVE_spiral_has_mapping_numbered': '%{values} spiraldiagram (%{number})',
	'LIVE_spiral_no_mapping': 'Tomt spiraldiagram',
	'LIVE_spiral_no_mapping_numbered': 'Tomt spiraldiagram (%{number})',
	'LIVE_spiral_named': '%{name} spiraldiagram',
	'LIVE_spiral_named_numbered': '%{name} spiraldiagram (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} efter %{size} træstrukturmapning',
	'LIVE_treemap_has_mapping_numbered': '%{categories} efter %{size} træstrukturmapning (%{number})',
	'LIVE_treemap_no_mapping': 'Tomt træstrukturkort',
	'LIVE_treemap_no_mapping_numbered': 'Tom træstrukturmapning (%{number})',
	'LIVE_treemap_named': '%{name} træstrukturmapning',
	'LIVE_treemap_named_numbered': '%{name} træstrukturmapning (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} ordsky',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} ordsky (%{number})',
	'LIVE_wordcloud_no_mapping': 'Tom ordsky',
	'LIVE_wordcloud_no_mapping_numbered': 'Tom ordsky (%{number})',
	'LIVE_wordcloud_named': '%{name} ordsky',
	'LIVE_wordcloud_named_numbered': '%{name} ordsky (%{number})',
	'LIVE_data_player_has_mapping': '%{category} dataafspiller',
	'LIVE_data_player_has_mapping_numbered': '%{category} dataafspiller (%{number})',
	'LIVE_data_player_no_mapping': 'Tom dataafspiller',
	'LIVE_data_player_no_mapping_numbered': 'Tom dataafspiller (%{number})',
	'LIVE_data_player_named': '%{name} dataafspiller',
	'LIVE_data_player_named_numbered': '%{name} dataafspiller (%{number})',
	'LIVE_map_has_mapping': '%{locations}-kort',
	'LIVE_map_has_mapping_numbered': '%{locations} kort (%{number})',
	'LIVE_map_no_mapping': 'Tomt kort',
	'LIVE_map_no_mapping_numbered': 'Tomt kort (%{number})',
	'LIVE_map_named': '%{name}-kort',
	'LIVE_map_named_numbered': '%{name} kort (%{number})',
	'LIVE_point_has_mapping': '%{categories} efter %{values} prikdiagram',
	'LIVE_point_has_mapping_numbered': '%{categories} efter%{values} prikdiagram (%{number})',
	'LIVE_point_no_mapping': 'Tomt punktdiagram',
	'LIVE_point_no_mapping_numbered': 'Tomt prikdiagram (%{number})',
	'LIVE_point_named': '%{name} prikdiagram',
	'LIVE_point_named_numbered': '%{name} prikdiagram (%{number})',
	'LIVE_column_has_mapping': '%{values} kolonnediagram',
	'LIVE_column_has_mapping_numbered': '%{values} kolonnediagram (%{number})',
	'LIVE_column_opt_mapping': '%{categories} efter %{values} kolonnediagram',
	'LIVE_column_opt_mapping_numbered': '%{categories} efter %{values} kolonnediagram (%{number})',
	'LIVE_column_no_mapping': 'Tomt kolonnediagram',
	'LIVE_column_no_mapping_numbered': 'Tomt kolonnediagram (%{number})',
	'LIVE_column_named': '%{name} kolonnediagram',
	'LIVE_column_named_numbered': '%{name} kolonnediagram (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} stakket kolonnediagram',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} stakket kolonnediagram (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} efter %{values} stakket kolonnediagram',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} efter%{values} stakket kolonnediagram (%{number})',
	'LIVE_stacked_column_no_mapping': 'Tomt stakket kolonnediagram',
	'LIVE_stacked_column_no_mapping_numbered': 'Tomt stakket kolonnediagram (%{number})',
	'LIVE_stacked_column_named': '%{name} stakket kolonnediagram',
	'LIVE_stacked_column_named_numbered': '%{name} stakket kolonnediagram (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} efter %{x} og %{y} punktdiagram',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} efter %{x} og %{y} punktdiagram (%{number})',
	'LIVE_scatter_has_mapping': '%{x} vs %{y} punktdiagram',
	'LIVE_scatter_has_mapping_numbered': '%{x} vs %{y} punktdiagram (%{number})',
	'LIVE_scatter_no_mapping': 'Tomt punktplot',
	'LIVE_scatter_no_mapping_numbered': 'Tomt punktdiagram (%{number})',
	'LIVE_scatter_named': '%{name} punktdiagram',
	'LIVE_scatter_named_numbered': '%{name} punktdiagram (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} vandfaldsdiagram',
	'LIVE_waterfall_has_mapping_numbered': '%{values} vandfaldsdiagram (%{number})',
	'LIVE_waterfall_no_mapping': 'Tomt vandfaldsdiagram',
	'LIVE_waterfall_no_mapping_numbered': 'Tomt vandfaldsdiagram (%{number})',
	'LIVE_waterfall_named': '%{name} vandfaldsdiagram',
	'LIVE_waterfall_named_numbered': '%{name} vandfaldsdiagram (%{number})',
	'LIVE_empty_visualization_hint_title': 'Byg din visualisering',
	'LIVE_empty_visualization_hint_description': 'Træk og placér kolonner hertil eller til pladserne til venstre.',
	'LIVE_slots_required_field_description': '%{asterisk} Angiver et påkrævet felt',
	'LIVE_slots_drag_and_drop_description': 'Træk og placér data til pladserne ovenfor for at bygge og filtrere visualiseringen.',
	'requiredField': 'Påkrævet felt',
	'fullScreenEnter': 'Start fuld skærm',
	'fullScreenClose': 'Afslut fuld skærm',
	'noExtraText_multipurpose': 'Pladsholder med flere formål',
	'noExtraText_multipurpose_numbered': 'Pladsholder til flere formål (%{number})',
	'one_placeholder_vis': 'Visualiseringspladsholder',
	'one_placeholder_vis_numbered': 'Visualiseringspladsholder (%{number})',
	'one_placeholder_text': 'Tekstpladsholder',
	'one_placeholder_text_numbered': 'Pladsholder til tekst (%{number})',
	'few_placeholder_text': 'Gruppe af%{count} pladsholdere til tekst',
	'many_placeholder_text': 'Gruppe af %{count} pladsholdere til tekst',
	'filter_includesAll': 'Inkluderer alle',
	'timeline_filter_moved_to': 'Tidslinjefilter %{id} flyttet til %{time}',
	'timelineSettingsButton': 'Indstillinger for playback',
	'autoPlay': 'Afspil alle scener',
	'loop': 'Løkke',
	'noSceneTransitionLabel': 'Ingen',
	'sceneTransitionPropertyLabel': 'Sceneovergang',
	'animatedPathSceneTransitionLabel': 'Animeret sti',
	'sweepSceneTransitionLabel': 'Glidende',
	'propAniAnimation': 'Animering',
	'propAniTypeEntrance': 'Indgangsanimation',
	'propAniDirectionIn': 'Indgangsretning',
	'propAniTypeExit': 'Afslutningsanimation',
	'propAniDirectionOut': 'Afslutningsretning',
	'propAniDirection': 'Retning',
	'timelineAnimationProperties': 'Åbn animationsegenskaber',
	'editStoryCoachMarkTitle': 'Redigér historie',
	'editStoryCoachMarkContents': 'Klik på blyantsikonen for at redigere historien.',
	'addDataStoryCoachMarkContents': 'Træk data fra datavinduet, og placér dem på historien.',
	'expandSceneCoachmarkTitle': 'Åbn tidslinje',
	'expandSceneCoachmarkContents': 'Animér en scene ved at justere objektsynligheden på basis af tid og varighed.',
	'overviewCoachmarkTitle': 'Oversigtsscener',
	'overviewCoachmarkContents': 'Brug oversigtsscenerne i starten og slutningen af historien til at give et indtryk af alle scener. Fra en oversigtsscene kan du klikke og trække en scene for at udskifte den med en anden scene. Du kan vise eller skjule oversigtsscener i egenskaberne til historien.',
	'animatedPathCoachmarkTitle': 'Animeret sti',
	'animatedPathCoachmarkContents': 'Duplikér en scene med et objekt for at animere et objekt fra én scene til en anden. Flyt, tilpas størrelse eller rotér det duplikerede objekt på den nye scene.',
	'tabName_animation': 'Animering',
	'textWidgetIconPlaceholderText': 'Klik for at tilføje tekst',
	'buildVisHeader': 'Opret en visualisering',
	'visIconPlaceholderText': 'Træk og placér felter for at bygge en visualisering',
	'launchNewExplore': 'Ny udforskning',
	'addTo': 'Tilføj til',
	'addToExisting': 'Tilføj til eksisterende...',
	'exploreData': 'Udforsk',
	'explore_remove_widget_styles': 'Tilpassede visualiseringsegenskaber, f.eks. farveindstillinger, bevares ikke i din udforskning.',
	'editNotebook': 'Redigér widget',
	'thumbnails_error_fetching': 'Fejl under hentning af miniaturer',
	'copy': '%{count} aktiver kopieret',
	'specConvertErr': 'Der er opstået en fejl under indsættelse eller konvertering af dashboardspecifikationen',
	'specCopyErr': 'Fejl under kopiering af dashboardspecifikation',
	'pasteNotSupportedErr': 'Indsættelse fra en %{name} understøttes ikke.',
	'reportParam': 'rapport',
	'filterWidgetCopyWarn': 'Filtervisualisering er ikke kopieret, fordi filtre ikke understøttes på nuværende tidspunkt.',
	'upgradingDashboard': 'Opgraderer "%{name}" for %{version}...',
	'upgradeComplete': 'Opgradering udført',
	'individualTabProperties': 'Egenskaber for individuelt skilleblad',
	'propMasterTabStylesLabel': 'Typografi for masterskilleblad',
	'propTabPosition': 'Skillebladsplacering',
	'propTabTitle': 'Titel',
	'propTabBackgroundColor': 'Udfyldningsfarve',
	'propTabTextColor': 'Titelfarve',
	'propTabSelectedBarColor': 'Farve på valgt søjle',
	'propTabRestoreDefaults': 'Gendan standardværdier',
	'propIndividualTabStylesLabel': 'Typografi for individuelt skilleblad',
	'propIndividualTabStylesAriaLabel': 'Åbn typografiegenskaber for individuelt skilleblad',
	'propTabIconPosition': 'Ikonplacering',
	'propLeftTitle': 'Venstre for titel',
	'propRightTitle': 'Højre for titel',
	'propTopTitle': 'Over titel',
	'propBottomTitle': 'Under titel',
	'propTabIconLabel': 'Visuel',
	'propTabIcon': 'Ikon',
	'propTabIconColor': 'Ikonfarve',
	'no_icon': 'Tom',
	'announcement': 'Annoncering',
	'api': 'API',
	'archive': 'Arkiv',
	'asset': 'Aktiv',
	'attachment': 'Vedhæftning',
	'audio': 'Audio',
	'bee': 'Bi',
	'blog': 'Blog',
	'bookmark': 'Bogmærke',
	'calendar': 'Kalender',
	'camera': 'Kamera',
	'capability': 'Funktion',
	'catalog': 'Katalog',
	'chat_message': 'Chatmeddelelse',
	'checkout_cart': 'Tjekoutkort',
	'client': 'Klient',
	'clock': 'Ur',
	'cloud': 'Sky',
	'code': 'Kode',
	'data_quality': 'Datakvalitet',
	'folder': 'Foldere',
	'forum': 'Forum',
	'glasses': 'Briller',
	'group': 'Gruppe',
	'hat': 'Hat',
	'headphone': 'Hovedtelefon',
	'hills': 'Bjerge',
	'home': 'Start',
	'idea': 'Idé',
	'image': 'Billede',
	'inventory': 'Lager',
	'like': 'Ligner',
	'link': 'Link',
	'location': 'Placering',
	'manage': 'Administrér',
	'pen': 'Pen',
	'mobile_phone': 'Mobiltelefon',
	'music': 'Musik',
	'notifications': 'Beskeder',
	'paint': 'Maleværktøj',
	'payment': 'Betaling',
	'password_key': 'Kodeordsnøgle',
	'people': 'Personer',
	'person': 'Person',
	'phone': 'Telefon',
	'pin': 'Fastgør',
	'print': 'Udskriv',
	'recording': 'Registrering',
	'repository': 'Opbevaringssted',
	'role': 'Rolle',
	'search': 'Søg',
	'properties': 'Egenskaber',
	'speaker': 'Taler',
	'star': 'Stjerne',
	'tag': 'Emneord',
	'thumbs_up': 'Tommel op',
	'thumbs_down': 'Tommel ned',
	'tools': 'Værktøjer',
	'traffic': 'Trafik',
	'trash': 'Papirkurv',
	'twitter': 'Twitter',
	'unknown': 'Ukendt',
	'user': 'Bruger',
	'venn_diagram': 'Venn-diagram',
	'video': 'Video',
	'view': 'Vis',
	'warning': 'Advarsel',
	'watch': 'Overvåg',
	'watson': 'Watson',
	'wikis': 'Wikier',
	'workspace': 'Arbejdsområde',
	'world': 'Verden',
	'OnLoadFilterModifierDatasourceMismatch': 'Filtre bliver ikke anvendt på målet, fordi dashboardene anvender forskelllige kilder.',
	'OnLoadFilterModifierColumnMismatch': 'Et eller flere filtre blev ikke anvendt, fordi der ikke fandtes matchende kolonner.',
	'eventGroupButtonLabel': 'Vis widgetforbindelser',
	'dockToolbar': 'Ophæv forankring af værktøjslinje',
	'undockToolbar': 'Forankring af værktøjslinje',
	'propShowTitle': 'Vis titel'
});
